import { Button, useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import EventsTable from '../../../components/Events/EventsTable';
import { columnsDataEvents } from './variables/columnsDataEvents.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js'; // Asegúrate de importar postData
import { useSearch } from '../../../contexts/SearchContext.js';
import EventsEditModal from '../../../components/Events/EventsEditModal.js'; // Asegúrate de importar el modal
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function Settings() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, event: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);

  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/events?${params.toString()}`);
      setData(response?.payload?.events || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      toast({
        title: 'Error al obtener eventos',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNewEventModal = () => {
    setModalState({ isOpen: true, event: { id: null, name: '' }, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, event: null, isNew: false });
  };

  // Función para crear un nuevo evento
  const handleCreateEvent = async (newEvent) => {
    try {
      await postData('/events', newEvent);
      loadData(searchQuery);
    } catch (error) {
      toast({
        title: 'Error al crear evento',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Función para actualizar un evento
  const handleUpdateEvent = async (event) => {
    try {
      await putData(`/events/${event.id}`, event);
      await loadData(searchQuery); 
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al actualizar evento',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Eventos"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewEventModal}>
          Nuevo evento
        </Button>
      }
    >
      <EventsTable
          columnsData={columnsDataEvents}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateEvent={handleUpdateEvent}
          sorting={sorting}
          onSortingChange={setSorting}
        />


      <EventsEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        event={modalState.event}
        isNew={modalState.isNew}
        onCreate={handleCreateEvent} 
      />
    </AdminPageShell>
  );
}